/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetEvidence200ResponseErrors
 */
export interface GetEvidence200ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'detectedDpi'?: GetEvidence200ResponseErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'calculatedDpi'?: GetEvidence200ResponseErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'colorGradation'?: GetEvidence200ResponseErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'heightMillis'?: GetEvidence200ResponseErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'widthMillis'?: GetEvidence200ResponseErrorsWidthMillisEnum;
}

export const GetEvidence200ResponseErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseErrorsDetectedDpiEnum = typeof GetEvidence200ResponseErrorsDetectedDpiEnum[keyof typeof GetEvidence200ResponseErrorsDetectedDpiEnum];
export const GetEvidence200ResponseErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseErrorsCalculatedDpiEnum = typeof GetEvidence200ResponseErrorsCalculatedDpiEnum[keyof typeof GetEvidence200ResponseErrorsCalculatedDpiEnum];
export const GetEvidence200ResponseErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidence200ResponseErrorsColorGradationEnum = typeof GetEvidence200ResponseErrorsColorGradationEnum[keyof typeof GetEvidence200ResponseErrorsColorGradationEnum];
export const GetEvidence200ResponseErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidence200ResponseErrorsHeightMillisEnum = typeof GetEvidence200ResponseErrorsHeightMillisEnum[keyof typeof GetEvidence200ResponseErrorsHeightMillisEnum];
export const GetEvidence200ResponseErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidence200ResponseErrorsWidthMillisEnum = typeof GetEvidence200ResponseErrorsWidthMillisEnum[keyof typeof GetEvidence200ResponseErrorsWidthMillisEnum];


